import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/archive";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-background-50">
      {/* 背景大号衬线水印字 */}
      <div className="pointer-events-none absolute -top-4 right-0 font-heading text-[9rem] md:text-[16rem] leading-none text-foreground-950/[0.03] select-none">
        八卦志
      </div>
      <span className="pointer-events-none absolute left-1/2 top-24 -translate-x-1/2 md:left-auto md:right-16 md:top-16 md:translate-x-0 text-background-100/0" />

      <div className="mx-auto max-w-[1200px] px-4 md:px-6 pt-28 md:pt-36 pb-14 md:pb-20">
        <div className="grid items-center gap-10 lg:gap-14 lg:grid-cols-[1.05fr_0.95fr]">
          {/* 左：报头文字 */}
          <div>
            <div className="anim-rise inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-70" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-600" />
              </span>
              <span className="text-xs font-medium text-primary-700">吃瓜雷达 · 六大分类实时更新</span>
            </div>

            <h1 className="anim-rise delay-1 mt-5 font-heading text-[2.1rem] leading-[1.15] md:text-6xl lg:text-[3.6rem] font-black text-foreground-950 tracking-tight">
              明星黑料，<br className="hidden md:block" />
              按<span className="text-primary-600">分类档案</span>一次吃透
            </h1>

            <p className="anim-rise delay-2 mt-5 max-w-xl text-base md:text-lg leading-8 text-foreground-600">
              人品争议、感情纠纷、耍大牌、违约失信、言论翻车、行为失当——把所有争议分门别类，
              系统梳理艺人塌房全过程。想找哪类瓜，就进哪类档案。
            </p>

            <div className="anim-rise delay-3 mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <Link
                to="/archive"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-600 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-folder-open-line text-base" />
                进入分类档案库
              </Link>
              <a
                href="/about#process"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-foreground-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-map-2-line text-base" />
                看塌房全过程
              </a>
            </div>

            <dl className="anim-rise delay-4 mt-9 grid grid-cols-3 max-w-md gap-4 border-t border-background-300/70 pt-6">
              {[
                ["06", "大分类档案"],
                ["120+", "实况条目"],
                ["04", "阶段全程拆解"],
              ].map(([n, l]) => (
                <div key={l}>
                  <dt className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{n}</dt>
                  <dd className="mt-1 text-xs text-foreground-500">{l}</dd>
                </div>
              ))}
            </dl>
          </div>

          {/* 右：卷宗分类速查 */}
          <div className="anim-rise delay-2 relative rounded-2xl border border-background-300/70 bg-background-100 overflow-hidden">
            <div className="flex items-center justify-between border-b border-background-300/70 px-5 py-3.5">
              <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <i className="ri-file-list-3-line text-primary-600" />
                档案卷宗 · 按标签速查
              </p>
              <span className="text-[10px] tracking-[0.2em] text-foreground-400 uppercase">Case Cabinet</span>
            </div>
            <div className="divide-y divide-background-200/80">
              {CATEGORIES.map((c, i) => (
                <Link
                  key={c.slug}
                  to={`/archive?cat=${c.slug}`}
                  className="group flex items-center gap-3.5 px-5 py-3.5 transition-colors hover:bg-background-200/60"
                >
                  <span className="font-heading text-sm font-bold text-foreground-300 tabular-nums w-5">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className={`grid place-items-center w-9 h-9 rounded-lg ${
                    c.accent === "accent" ? "bg-accent-100 text-accent-700" : "bg-primary-100 text-primary-700"
                  }`}>
                    <i className={`${c.icon} text-base`} />
                  </span>
                  <span className="flex-1 min-w-0">
                    <span className="block text-sm font-semibold text-foreground-900">{c.name}黑料</span>
                    <span className="block truncate text-xs text-foreground-500">{c.tagline}</span>
                  </span>
                  <i className="ri-arrow-right-s-line text-lg text-foreground-300 transition-all group-hover:text-primary-600 group-hover:translate-x-0.5" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}